import { checkboxClasses } from '@mui/material/Checkbox';

import {
  CHECKBOX_BORDER_CLASS,
  CHECKBOX_CHECKED_ICON,
  CHECKBOX_FILL_CLASS,
  CHECKBOX_GLYPH_CLASS,
  CHECKBOX_ICON,
  CHECKBOX_ICON_CLASS,
  CHECKBOX_INDETERMINATE_ICON,
} from 'theme/components/checkbox-icons';
import {
  SELECTION_CONTROL_ACTIVE_STATES,
  selectionControlHalo,
  selectionControlSizeVariants,
  selectorsWithin,
} from 'theme/components/selection-control';
import type { ComponentOverrides } from 'theme/theme.types';

const BORDER = `.${CHECKBOX_BORDER_CLASS}`;
const FILL = `.${CHECKBOX_FILL_CLASS}`;
const GLYPH = `.${CHECKBOX_GLYPH_CLASS}`;
const SELECTED = [
  `&.${checkboxClasses.checked}`,
  `&.${checkboxClasses.indeterminate}`,
];
const DISABLED = `&.${checkboxClasses.disabled}`;

export const MuiCheckbox: ComponentOverrides['MuiCheckbox'] = {
  defaultProps: {
    disableRipple: true,
    icon: CHECKBOX_ICON,
    checkedIcon: CHECKBOX_CHECKED_ICON,
    indeterminateIcon: CHECKBOX_INDETERMINATE_ICON,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      variants: selectionControlSizeVariants,
      ...selectionControlHalo(theme),
      [`& ${BORDER}`]: { color: theme.palette.tokens.navy[400] },
      [`& ${FILL}`]: { color: theme.palette.background.paper },
      [`& ${GLYPH}`]: { color: theme.palette.secondary.contrastText },
      [selectorsWithin(SELECTION_CONTROL_ACTIVE_STATES, BORDER)]: {
        color: theme.palette.secondary.main,
      },
      [selectorsWithin(SELECTED, BORDER)]: {
        color: theme.palette.secondary.main,
      },
      [selectorsWithin(SELECTED, FILL)]: {
        color: theme.palette.secondary.main,
      },
      [`${DISABLED} ${BORDER}`]: { color: theme.palette.action.disabledBorder },
      [`${DISABLED} ${FILL}`]: {
        color: theme.palette.action.disabledBackground,
      },
      [`${DISABLED} ${GLYPH}`]: { color: theme.palette.action.disabled },
      '@media (forced-colors: active)': {
        [`& .${CHECKBOX_ICON_CLASS}`]: { forcedColorAdjust: 'none' },
        [`& ${BORDER}`]: { color: 'CanvasText' },
        [`& ${FILL}`]: { color: 'Canvas' },
        [`& ${GLYPH}`]: { color: 'HighlightText' },
        [selectorsWithin(SELECTED, BORDER)]: { color: 'Highlight' },
        [selectorsWithin(SELECTED, FILL)]: { color: 'Highlight' },
        [`${DISABLED} ${BORDER}`]: { color: 'GrayText' },
        [`${DISABLED} ${FILL}`]: { color: 'Canvas' },
        [`${DISABLED} ${GLYPH}`]: { color: 'GrayText' },
      },
    }),
  },
};
